import { z } from 'zod';
import { SortQuerySchema } from '../common';

export const SECCION_COBRADOR = ['hoy', 'pendientes', 'visitas'] as const;
export type SeccionCobrador = (typeof SECCION_COBRADOR)[number];

export const QueryCobradorClientesDtoSchema = z
  .object({
    seccion: z.enum(SECCION_COBRADOR),
    offset: z.coerce.number().int().min(0).default(0),
    limit: z.coerce.number().int().min(1).max(100).default(20),
  })
  .merge(SortQuerySchema);

export type QueryCobradorClientesDto = z.infer<typeof QueryCobradorClientesDtoSchema>;

/**
 * Query del tab `Cerca`: snapshot de posición del cobrador (lat/lon del
 * navegador) y radio de búsqueda en metros. Las opciones de radio de la UI
 * son 250/500/1000/3000 m; los bounds del contrato las cubren. Solo se
 * consultan las secciones `hoy` y `pendientes` de la worklist (saldo
 * pendiente positivo), nunca `visitas`.
 */
export const QueryCobradorCercaDtoSchema = z
  .object({
    latitud: z.coerce.number().finite().min(-90).max(90),
    longitud: z.coerce.number().finite().min(-180).max(180),
    radioMetros: z.coerce.number().int().min(1).max(3000).default(1000),
    limit: z.coerce.number().int().min(1).max(100).default(20),
  })
  .refine((value) => value.latitud !== 0 || value.longitud !== 0, {
    path: ['latitud'],
    message: 'GPS coordinates cannot be the 0,0 sentinel',
  });

export type QueryCobradorCercaDto = z.infer<typeof QueryCobradorCercaDtoSchema>;
